/**
 * Period abbreviation identifiers used across the app.
 *
 * **Start-date non-business day adjustment rules:**
 *
 * For Max or numerical inputs, move the start date to the **next** business day after it:
 * `MAX`, `LIVE`, `10Y`, `5Y`, `3Y`, `1Y`, `6M`, `3M`, `1M`, `CUSTOM`
 *
 * For preset periods, move the start date to the **previous** business day:
 * `YTD`, `QTD`, `MTD`, `WTD`, `1D`
 */
export enum PeriodAbbrevEnum {
  TEN_Y = '10Y',
  FIVE_Y = '5Y',
  THREE_Y = '3Y',
  ONE_Y = '1Y',
  SIX_M = '6M',
  THREE_M = '3M',
  TWO_M = '2M',
  ONE_M = '1M',
  ONE_D = '1D',

  // all periods below function as custom periods
  CUST = 'CUSTOM',
  LIVE = 'LIVE',

  MAX = 'MAX',
  YTD = 'YTD',
  QTD = 'QTD',
  MTD = 'MTD',
  WTD = 'WTD',
  MIN = 'MIN',
}
